{
  "brand": "VBB PLAY",
  "tagline": "Платформаи бозии премиум",
  "loading": "Бор шуда истодааст…",
  "retry": "Дубора кӯшиш",
  "close": "Пӯшидан",
  "search": "Ҷустуҷӯ",
  "seeAll": "Ҳамаро дидан",
  "comingSoon": "Ба наздикӣ",
  "currency": "AZN",
  "language": "Забон",
  "selectLanguage": "Забонро интихоб кунед",
  "offlineHint": "Пайвастсанҷӣ",
  "footerRights": "© {{year}} VBB PLAY. Ҳамаи ҳуқуқҳо ҳифз шудаанд.",
  "footerSupport": "Дастгирӣ",
  "heroEyebrow": "PLAY BEYOND LIMITS",
  "heroTitle": "Бозиҳои калон. Бурдҳои ҷасурона.",
  "heroSubtitle": "Аз ҳудудҳо гузаред — лоббӣи премиум, хазинаи бехатар ва каталоги интихобшуда.",
  "heroCta": "Ҳоло бозӣ кунед",
  "promoFallbackTitle": "Клуби бонусии VBB PLAY",
  "promoFallbackSubtitle": "Барномаҳои бонус ва VIP омода мешаванд. Огоҳиномаҳо ба наздикӣ фаъол мегарданд.",
  "promoFallbackCta": "Ба наздикӣ",
  "login": "Вуруд",
  "promoFilter_all": "All",
  "promoFilter_welcome": "Welcome",
  "promoFilter_casino": "Casino",
  "promoFilter_sports": "Sports",
  "promoFilter_vip": "VIP",
  "storyBonuses": "Бонусҳо",
  "storyVip": "VIP",
  "storyCashback": "Кэшбэк",
  "storyCrypto": "Крипто",
  "bonusSelectTitle": "Бонус интихоб кунед",
  "continue": "Давом додан",
  "supportWelcome": "Ба VBB PLAY хуш омадед",
  "supportPrechat": "Пеш аз оғози гуфтугӯ тамос ва саволро нависед.",
  "supportEmail": "Email",
  "supportName": "Ном",
  "supportMessage": "Паём",
  "supportConsent": "Ба коркарди маълумоти шахсӣ розӣ ҳастам.",
  "startDialogue": "Оғози гуфтугӯ",
  "attach": "Замима",
  "send": "Фиристодан",
  "support247": "Дастгирӣ 24/7",
  "supportInvite": "Операторҳо омодаанд.",
  "contactSupport": "Бо дастгирӣ тамос",
  "infoSection": "Маълумот",
  "referral": "Реферал",
  "liveSports": "Зинда",
  "prematch": "Прематч",
  "fiatMethods": "Фиат",
  "fiatMethodsHint": "Корт, M10, Терминал",
  "cryptoMethodsHint": "Криптовалютаҳои дастгирӣшаванда дар хазина",
  "personalInfo": "Маълумоти шахсӣ",
  "contactInfo": "Тамос",
  "displayName": "Ном",
  "notAvailable": "Дастрас нест",
  "phone": "Телефон",
  "profileEditHint": "Ном, санаи таваллуд ва ҷинс дар ҳисоб нигоҳ дошта мешаванд.",
  "myProfile": "Профили ман",
  "securitySettings": "Амният",
  "rewardCenter": "Маркази мукофот",
  "notificationsTitle": "Огоҳиномаҳо",
  "markAllRead": "Ҳамаро хондашуда қайд кун",
  "marketingOptIn": "Огоҳиномаҳои таблиғотӣ гирифтан",
  "emptyNotifications": "Огоҳинома нест",
  "notificationsUnavailable": "Огоҳиномаҳои рӯйдод дар ин ҷо пайдо мешаванд.",
  "open": "Кушодан",
  "protectionTitle": "Муҳофизати ҳисоб",
  "coolingOff": "Муддати хунукшавӣ",
  "selfExclude": "Худро маҳдуд кардан",
  "requestClosure": "Пӯшидани ҳисобро дархост кун",
  "helpSupport": "Кӯмак ва дастгирӣ",
  "promoCode": "Промокод",
  "redeem": "Фаъол кардан",
  "bonusHistory": "Таърихи бонус",
  "promoLoginRequired": "Барои фаъол кардани код ворид шавед.",
  "promoSuccess": "{{amount}} AZN ҳисоб шуд",
  "promo_invalid_code": "Ин код эътибор надорад.",
  "promo_campaign_expired": "Муҳлати аксия гузашт.",
  "promo_campaign_inactive": "Ин аксия фаъол нест.",
  "promo_campaign_not_started": "Ин аксия ҳанӯз оғоз нашудааст.",
  "promo_per_user_limit": "Шумо ин кодро аллакай истифода кардед.",
  "promo_unique_user_limit": "Ҳудуди бозингарони аксия пур шуд.",
  "promo_usage_limit": "Барои ин аксия фаъолкунӣ намонд.",
  "promo_not_eligible": "Шумо ба ин аксия мувофиқ нестед.",
  "promo_minimum_deposit_not_satisfied": "Депозити мувофиқ лозим аст.",
  "promo_budget_exhausted": "Буҷаи аксия тамом шуд.",
  "promo_too_many_requests": "Кӯшишҳо зиёданд. Баъдтар такрор кунед.",
  "promo_zero_reward": "Ин аксия дар ин ҷо мукофоти пулӣ надорад.",
  "promo_redeem_failed": "Кодро фаъол кардан нашуд.",
  "storyPromo": "Промокод",
  "liveSupport": "Дастгирии зинда",
  "sportsUnavailable": "Шартгузории варзишӣ ҳоло дастрас нест. Казино кушода аст.",
  "linked": "Пайваст шудааст",
  "notLinked": "Пайваст нашудааст",
  "loadFailed": "Бор карда нашуд",
  "unavailableTitle": "Дастрас нест",
  "vipUnavailable": "Сатҳҳои VIP ҳоло танзим нашудаанд.",
  "givenName": "Ном",
  "familyName": "Насаб",
  "dateOfBirth": "Санаи таваллуд",
  "gender": "Ҷинс",
  "genderMale": "Мард",
  "genderFemale": "Зан",
  "genderOther": "Дигар",
  "genderPreferNot": "Намехоҳам бигӯям",
  "saveProfile": "Профилро захира кун",
  "profileSaved": "Профил захира шуд",
  "profileSaveFailed": "Профил захира нашуд",
  "identityLockedNotice": "Маълумоти шахсии шумо сабт шудааст. Барои тағйир ба дастгирии зинда муроҷиат кунед.",
  "identityChangeRequest": "Дархости тағйир",
  "identityChangeReason": "Сабаби тағйир",
  "identitySubmitRequest": "Дархостро фиристед",
  "identityChangePending": "Дархости шумо баррасӣ мешавад.",
  "identityChangeSubmitted": "Дархост фиристода шуд. Дастгирии зинда пайгирӣ мекунад.",
  "identityChangeFailed": "Дархост фиристода нашуд.",
  "identityNoChanges": "Тағйире барои дархост нест.",
  "createdAt": "Ҳисоб сохта шуд",
  "ageIneligible": "Ин санаи таваллуд аз синни қонунӣ поён аст. Бозии пули ҳақиқӣ хомӯш мемонад.",
  "rateOperator": "Суҳбатро баҳо диҳед",
  "ratingComment": "Шарҳ (ихтиёрӣ)",
  "submitRating": "Баҳо фиристед",
  "ratingThanks": "Барои баҳо сипос",
  "footerRules": "Қоидаҳо",
  "footerPrivacy": "Махфият",
  "rulesLink": "Қоидаҳо ва сиёсатҳо",
  "footerLegalTitle": "Маълумоти ҳуқуқӣ",
  "footerLegalDraftBadge": "ЛОИҲА",
  "footerLegalDraftNotice": "Реквизитҳои зерин танҳо ҳамчун лоиҳаи маҳаллии ҳуқуқӣ пешниҳод шудаанд. То тасдиқи бақайдгирии ширкат ва иҷозатнома, тасдиқ шудани онҳо, иҷозатномадор будани VBB PLAY ё салоҳияти қонунан анҷом додани тамоми фаъолияти қиморӣ даъво карда намешавад.",
  "footerCompanyLabel": "Ширкат",
  "footerCompanyName": "Vbb Play Byte Lab Sociedad de Responsabilidad Limitada",
  "footerCountryLabel": "Кишвари бақайдгирӣ",
  "footerCountryValue": "Коста-Рика",
  "footerRegNumberLabel": "Рақами бақайдгирӣ",
  "footerRegNumberValue": "2-101-918934",
  "footerAddressLabel": "Суроғаи ҳуқуқӣ",
  "footerAddressValue": "Provincia 04 San Jose, Canton 02 Escazu, San Rafael, 200 метр ҷанубтар аз кинотеатрҳои Multiplaza de Escazu, кӯчаи Seiba, Centro Corporativo EBC, ошёнаи даҳум, дафтари Invicta Legal.",
  "footerLicenseNumberLabel": "Рақами пешниҳодшудаи иҷозатнома",
  "footerLicenseNumberValue": "ALSI-207508070-FI1",
  "footerLicenseJurisdictionLabel": "Юрисдиксияи пешниҳодшудаи иҷозатнома",
  "footerLicenseJurisdictionValue": "Анжуан, Иттиҳоди Ҷазираҳои Комор",
  "footerLegalAria": "Маълумоти ҳуқуқӣ",
  "footerLegalStatement": "© 2026 VBB Play. vbbplay.com Kosta-Rikada qeydiyyatdan keçmiş Vbb PLay Byte Lab Sociedad de Responsabilidad Limitada şirkətinə məxsusdur və onun tərəfindən idarə olunur, qeydiyyat nömrəsi 2-101-918934, hüquqi ünvanı: Provincia 04 San Jose, Canton 02 Escazu, San Rafael, Multiplaza de Escazu kinoteatrlarından 200 metr cənubda, Seiba küçəsi, Centro Corporativo EBC, onuncu mərtəbə, Invicta Legal ofisi. vbbplay.com Komor Adaları İttifaqının Avtonom Anjuan Adası Hökuməti tərəfindən lisenziyalaşdırılıb və tənzimlənir və ALSI-207508070-FI1 nömrəli lisenziya əsasında fəaliyyət göstərir. VbbPlay.com bütün tənzimləyici tələblərdən keçmişdir və hər cür qumar oyunları və mərc əməliyyatlarını qanuni şəkildə həyata keçirməyə səlahiyyətlidir.",
  "back": "Бозгашт",
  "rulesSelectAria": "Ҳуҷҷати ҳуқуқиро интихоб кунед",
  "scrollToTop": "Ба боло",
  "footerAria": "Поёни сайт",
  "footerLiveCasino": "Казинои зинда",
  "footerProviders": "Провайдерҳо",
  "footerFastGames": "Бозиҳои зуд",
  "footerEsports": "Киберспорт",
  "footerTournaments": "Мусобиқаҳо",
  "footerPartnership": "Барномаи шарикӣ",
  "footerTechSupport": "Дастгирии техникӣ",
  "footerSupportSecurity": "Дастгирӣ ва амният",
  "footerSocial": "Шабакаҳои иҷтимоӣ",
  "footerSocialPending": "Ҳисобҳои расмии иҷтимоӣ пас аз тасдиқ дар ин ҷо кушода мешаванд.",
  "footerAgeHint": "Танҳо 18+",
  "footerLegalAccordionTitle": "Маълумоти ҳуқуқӣ"
}
